export default __webpack_public_path__ + "static/media/minio2.92301577.jpg";